import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-midnight text-bone mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <img src="/zyro-logo.png" alt="Zyro" className="h-12 w-auto object-contain brightness-0 invert" />
          </div>
          <p className="text-gold text-xs tracking-[0.3em] uppercase mb-4">Connect · Grow · Earn</p>
          <p className="text-neutral-400 text-sm max-w-md leading-relaxed">
            India's trusted platform for handpicked hotels and long-term rentals.
            Verified owners, secure payments, transparent stays.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4 text-gold">Explore</h4>
          <ul className="space-y-2 text-sm text-neutral-400">
            <li><Link to="/hotels" className="hover:text-white transition-colors">Hotels</Link></li>
            <li><Link to="/rentals" className="hover:text-white transition-colors">Rentals</Link></li>
            <li><Link to="/help" className="hover:text-white transition-colors">Help Center</Link></li>
            <li><Link to="/bookings" className="hover:text-white transition-colors">My Trips</Link></li>
            <li><Link to="/my-rentals" className="hover:text-white transition-colors">My Rentals</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg mb-4 text-gold">Contact</h4>
          <ul className="space-y-2 text-sm text-neutral-400">
            <li>
              <a href="mailto:conect@zyroapp.in" className="hover:text-white transition-colors" data-testid="footer-email">
                conect@zyroapp.in
              </a>
            </li>
            <li>
              <a href="tel:+919262592844" className="hover:text-white transition-colors" data-testid="footer-phone">
                +91 92625 92844
              </a>
            </li>
            <li>India</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs text-neutral-500 tracking-wider uppercase">
            © {new Date().getFullYear()} Zyro Hospitality. All rights reserved.
          </p>
          <div className="flex gap-5 text-xs text-neutral-500 tracking-wider uppercase">
            <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy">Privacy</Link>
            <Link to="/help" className="hover:text-white transition-colors">Help</Link>
            <span>Crafted for luxury travellers</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
